import { useCallback, useMemo } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import { AXNUIContent } from "@iddataweb/idw-common-ui/types";
import { AttributeFormState } from "@idw-types/state/attribute-form-state";
import { AttributeTypeField } from "@idw-types/data";
import styles from "./custom-attribute-field-input-label.less";

type CustomAttributeTypeFieldInputLabelProps = {
    attribute: AttributeFormState;
    attributeTypeField: AttributeTypeField;
    attributeLabel: string;
    content: AXNUIContent;
    isRadioGroup: boolean;
};

export const CustomAttributeTypeFieldInputLabel = (props: CustomAttributeTypeFieldInputLabelProps) => {
    const {
        attribute,
        attributeTypeField,
        attributeLabel,
        content,
        isRadioGroup
    } = props;

    const renderTooltip = useCallback((props: any) => (
        <Tooltip id={`attr-${attribute.id}-${attributeTypeField.name}-tooltip`} {...props}>
            <span>{attribute.customTooltip}</span>
        </Tooltip>
    ), [attribute.id, attributeTypeField.name, attribute.customTooltip]);

    const labelContent = useMemo(() => {
        return (
            <>
                {attributeLabel}{' '}
                {attribute.optional
                    ? content.form.genericInput.optional
                    : <span className={`required ${styles.required}`}>*</span>
                }
            </>
        )
    }, [
        attributeLabel,
        attribute.optional,
        content.form.genericInput.optional,
        attribute.id,
        isRadioGroup
    ]);

    const tooltipContent = useMemo(() => {
        if (attribute.customTooltip) {
            return (
                <OverlayTrigger
                    placement="right"
                    overlay={renderTooltip}
                >
                    <span className={styles.tooltipSpan}>
                        <FontAwesomeIcon id={`attr-${attribute.id}-${attributeTypeField.name}-tooltip-icon`} className={styles.tooltipIcon} icon={faQuestionCircle} />
                    </span>
                </OverlayTrigger>
            );
        }

        return null;
    }, [
        renderTooltip,
        attribute.customTooltip,
        attribute.id,
        attributeTypeField.name
    ]);

    return isRadioGroup ? (
        <legend className={styles.genericInputHeader} id={`attr${attribute.id}-${attributeTypeField.name}-label`}>
            {labelContent}
            {tooltipContent}
        </legend>
    ) : (
        <div className={styles.genericInputHeader}>
            <label id={`attr${attribute.id}-${attributeTypeField.name}-label`}>
                {labelContent}
            </label>
            {tooltipContent}
        </div>
    );
};